export default "__VITE_ASSET__Cnx$ArMT__"